

















































import { defineComponent } from '@nuxtjs/composition-api';
import { BaseCard, TypeBody, TypeDisplay, BaseButton } from '@bambeehr/pollen';

export default defineComponent({
  components: {
    TypeDisplay,
    TypeBody,
    BaseCard,
    BaseButton,
  },
  props: {
    label: {
      type: String,
      default: 'Courses',
    },
    topicList: {
      type: Array,
      required: true,
    },
  },
});
